import { MonthsDateRangeType } from '@app/core/date-range/enums/months-date-range-type.enum';

export const MonthsDateRangeTypeConfig = {
  [MonthsDateRangeType.One]: 1,
  [MonthsDateRangeType.Three]: 3,
  [MonthsDateRangeType.Six]: 6,
  [MonthsDateRangeType.Twelve]: 12,
  [MonthsDateRangeType.TwentyFor]: 24,
  [MonthsDateRangeType.FullHistory]: null,
};
